export default __webpack_public_path__ + "static/media/discord_icon.9a823ca6.svg";